import * as RDF from './lib/data-factory.js'

export * from './lib/data-factory.js'

export default { ...RDF }
